import { CognitoUserPool } from "amazon-cognito-identity-js";
import { config, paths } from "../common/constant";
import { decryptData, getSecret } from "../common";

let loginPool = null;

export async function getLoginPool() {
    if (loginPool) {
        return loginPool;
    }

    const environment = config.TYPE.toLowerCase();

    const poolIdParamName = `/${environment}${paths.CognitoLoginAccessKey}`;
    const clientIdParamName = `/${environment}${paths.CognitoLoginClientId}`;

    const [rawPoolId, rawClientId] = await Promise.all([
        getSecret(poolIdParamName),
        getSecret(clientIdParamName),
    ]);


    const poolId = decryptData(rawPoolId);
    const clientId = decryptData(rawClientId);

    console.log("DEBUG getLoginPool decrypted values:", { poolId, clientId });

    loginPool = new CognitoUserPool({
        UserPoolId: poolId,
        ClientId: clientId,
    });

    return loginPool;
}